import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "icon-trash-can" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = {
  key: 0,
  fill: "none",
  "fill-rule": "evenodd"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<g transform=\"translate(-1141.000000, -960.000000) translate(835.000000, 864.000000) translate(22.000000, 57.000000) translate(284.000000, 39.000000)\"><path stroke=\"#ffffff\" stroke-width=\"1.5\" d=\"M19.313 5.878L17.688 21.316 6.313 21.316 4.688 5.878\" class=\"icon-trash-can__path\"></path><path stroke=\"#ffffff\" fill=\"#D8D8D8\" d=\"M2.5 5.566H21.5V6.566H2.5z\" class=\"icon-trash-can__path\"></path><path stroke=\"#ffffff\" stroke-width=\"1.5\" d=\"M8.499 5.584L10.291 2 13.709 2 15.501 5.584\" class=\"icon-trash-can__path\"></path><path d=\"M0 0H24V24H0z\"></path></g>", 1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("title", null, _toDisplayString(_ctx.title), 1),
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("g", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true)
    ]))
  ]))
}